import { UseAuthResult } from "core/auth/model";
import { StatusPage } from "UIPalette/StatusPage/StatusPage";
import { onLogout } from "core/javascriptChannels";
import { useTranslation } from "react-i18next";

interface AuthErrorProps {
  auth: UseAuthResult;
}

export const AuthError = ({ auth }: AuthErrorProps) => {
  const { t } = useTranslation();

  return (
    <StatusPage
      status="error"
      title={t("auth.error.title")}
      body={t("auth.error.description")}
      cta={{
        id: "login-status-confirm-button",
        text: t("auth.error.button"),
        onClick: () => {
          auth.signoutRedirect();
          onLogout();
        },
      }}
    />
  );
};
